const MS_IN_YEAR = 1000 * 60 * 60 * 24 * 365.25;

const toFiniteNumber = (value) => {
  if (value === null || value === undefined || value === '') return Number.NaN;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : Number.NaN;
};

const calculateLifeInYears = (asset) => {
  const parsedLifeInYears = toFiniteNumber(asset?.lifeInYears);
  if (Number.isFinite(parsedLifeInYears) && parsedLifeInYears > 0) {
    return parsedLifeInYears;
  }

  if (!asset?.assetStartDate || !asset?.assetEndDate) {
    return null;
  }

  const start = new Date(asset.assetStartDate);
  const end = new Date(asset.assetEndDate);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
    return null;
  }

  const diff = end.getTime() - start.getTime();
  if (!(diff > 0)) {
    return null;
  }

  return diff / MS_IN_YEAR;
};

export const calculateMeterEndOfLife = (asset, utilisation) => {
  const parsedUtilisation = toFiniteNumber(utilisation);
  if (!Number.isFinite(parsedUtilisation) || parsedUtilisation <= 0) {
    return null;
  }

  const years = calculateLifeInYears(asset);
  if (!Number.isFinite(years) || years <= 0) {
    return null;
  }

  return Math.round(years * parsedUtilisation);
};

export const resolveMeterEndOfLifeValue = (asset, meter, manualPrimaryValue) => {
  const startReading = toFiniteNumber(meter?.startReading);
  const startReadingValue = Number.isFinite(startReading) ? startReading : 0;

  if (Number(meter?.primaryMeter) === 1) {
    const manual = toFiniteNumber(manualPrimaryValue);
    if (Number.isFinite(manual) && manual >= 0) {
      return Math.round(manual);
    }
  }

  const calculated = calculateMeterEndOfLife(asset, meter?.utilisation ?? null);
  if (calculated == null) {
    return calculated;
  }

  if (Number(meter?.primaryMeter) === 1) {
    return Math.round(calculated + startReadingValue);
  }

  return calculated;
};

export default calculateMeterEndOfLife;
